var header = 'fx_2d2fb1e5_11q87so0';

export { header };
//# sourceMappingURL=header.vanilla.mjs.map
